import { Route } from "components/utils";
import { NotFound } from "pages/notFound";
import { InventoryChecksList } from "pages/wms/inventoryChecksList/InventoryChecksList";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

export const InventoryChecks = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        component={InventoryChecksList}
        exact={true}
        path={`${match.path}/list/:tab`}
        title="Milo - WMS - inwentaryzacje"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
